<div [ngClass]="{ toggled: burgerOpen }" class="side-container" [formGroup]="formGroup">
  <div class="scroll-container" formArrayName="sections">
    <div class="overview">
      <div>Template Overview</div>
    </div>

    <div (cdkDropListDropped)="drop($event)" cdkDropList class="bars-container">
      <button class="bar-item no-cursor" [disabled]="true" type="button">
        <div class="drag-handle">
          <fa-icon icon="ban"></fa-icon>
        </div>
        <div class="section-title">Information</div>
      </button>

      @for (item of sections.controls; track item) {
        <button
          cdkDragBoundary=".bars-container"
          cdkDrag
          (click)="setItem($index)"
          [ngClass]="{ active: $index === activeSectionIndex }"
          class="bar-item"
          type="button">
          <div cdkDragHandle class="drag-handle icon-browse-all"></div>

          <ng-container formGroupName="{{ $index }}">
            <input class="section-title" readonly [value]="getControl(item, 'title')?.value" placeholder="Enter Section Title" />
          </ng-container>

          @if (sections.controls.length > 1) {
            <span class="trash icon-delete" (click)="removeSection($index)"></span>
          }
        </button>
      }

      <button class="bar-item no-cursor" [disabled]="true" type="button">
        <div class="drag-handle">
          <fa-icon icon="ban"></fa-icon>
        </div>
        <div class="section-title">Signatures</div>
      </button>
    </div>
  </div>
</div>
